import { useLocation } from 'react-router-dom'

export const pages = [
  '',
  'customer',
  'insured',
  'company',
  'activity',
  'turnover',
  'contacts',
  'loading',
  'estimate',
  'activation',
  'frequency',
  'resume',
  'payment-choice',
  'payment',
  'signature-choice',
  'signature'
]

export const GetPageIndex = () => {
  const { pathname } = useLocation()
  const currentPage = pathname.split("/")[3]?.split("?")[0]
  const index = pages.findIndex(page => page === currentPage)

  return currentPage && index !== -1
    ? index
    : 0
}

export const nextPage = ({pathname, navigate, state, data}) => {
  const pathSplit = pathname.split('/')
  const project = pathSplit[1]
  const currentPage = pathSplit[3]?.split("?")[0]
  const index = pages.findIndex(page => page === currentPage)
  const page = pages[index+1]
  const savedState = {
    ...state,
    ...(data || {}),
    issues: []
  }

  // Save state
  localStorage.setItem(project === 'rc-pro' ? 'RCPro' : project, JSON.stringify({
    page, savedState
  }))

  // Next page
  setTimeout( () => {
    navigate('../'+page, {
      state: savedState
    })
  }, 250)
}